import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, totalElements, pageSize, onPageChange, onPageSizeChange }) => {
    return (
        <div className="pagination">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Hiển thị
                <select
                    style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ddd' }}
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </select>
                trên 1 trang (Tổng: {totalElements})
            </div>
            <div className="page-numbers">
                <button
                    className="page-btn"
                    onClick={() => onPageChange(Math.max(0, currentPage - 1))}
                    disabled={currentPage === 0}
                >
                    <ChevronLeft size={16} />
                </button>
                {[...Array(Math.min(5, totalPages))].map((_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                        pageNum = i;
                    } else if (currentPage < 3) {
                        pageNum = i;
                    } else if (currentPage >= totalPages - 3) {
                        pageNum = totalPages - 5 + i;
                    } else {
                        pageNum = currentPage - 2 + i;
                    }

                    return (
                        <button
                            key={pageNum}
                            className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                            onClick={() => onPageChange(pageNum)}
                        >
                            {pageNum + 1}
                        </button>
                    );
                })}
                {totalPages > 5 && currentPage < totalPages - 3 && (
                    <>
                        <span style={{ display: 'flex', alignItems: 'end', paddingBottom: '4px' }}>...</span>
                        <button
                            className="page-btn"
                            onClick={() => onPageChange(totalPages - 1)}
                        >
                            {totalPages}
                        </button>
                    </>
                )}
                <button
                    className="page-btn"
                    onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
                    disabled={currentPage === totalPages - 1}
                >
                    <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
